import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import Features from './components/Features';
import Download from './components/Download';
import Footer from './components/Footer';
import './Landing.css';

function LandingPage() {
  return (
    <>
      <Navbar />
      <Hero />
      <Services />
      <Features />
      <Download />
      <Footer />
    </>
  );
}

export default LandingPage;
